export const removeNonPrintableCharacters = (
  inputString: string | null,
): string | null => {
  if (inputString === null || inputString === undefined) {
    return inputString;
  }

  // Search for non-printable character line separator and replace it with a new line
  const pattern = /\u2028/g;
  const nonPrintableRegex = new RegExp(pattern, 'g');

  return inputString.replace(nonPrintableRegex, '\n');
};
